import { ColumnAdapter } from '@makyoapp/makyo-common'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { SHOW_SEARCH_LIMIT } from '@/shared/constants'

import { RenderColumn } from '../RenderColumn'

export function ColumnConditionSelect({
  id,
  colOptions,
  value,
  onChange,
  className,
}: {
  id?: string
  colOptions: ColumnAdapter[]
  value?: string
  onChange: (value: string) => void
  className?: string
}) {
  return (
    <SelectDropdown
      toggleClassName='dark:hover:bg-slate-800!'
      id={id}
      value={colOptions.find((c) => c.id === value) ?? colOptions[0]}
      options={colOptions}
      onChange={(opt) => onChange(opt.id)}
      optionLabel={(opt) => `${opt.id} ${opt.name}`}
      renderOption={(opt) => <RenderColumn withStyle={false} col={opt} />}
      withSearch={colOptions.length > SHOW_SEARCH_LIMIT}
      menuContainerClassName='min-w-[200px]'
      className={className}
    />
  )
}
